/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
export const COMPONENT_NAME = `@uim/operatorconsole-ui`
export const VERSION = `0.1.0`
export const BUILD_DATE = `2024-01-04T14:13:51.353Z`
export const BUILD_NUMBER = `0`
export const BRANCH = `master`
export const COMMIT_ID = `59d88fdcab153a3207145fda8d83636bcbab30a8`
// export const TAGS = '${git.tags}';
// export const DIRTY = '${git.dirty}';
// export const DESCRIBE = '${git.commit.id.describe}';
// export const COMMIT_TIME = '${git.commit.time}';
// export const CLOSEST_TAG_NAME = '${git.closest.tag.name}';
// export const CLOSEST_TAG_COMMIT_COUNT = '${git.closest.tag.commit.count}';

export default {
  COMPONENT_NAME,
  VERSION,
  BUILD_DATE,
  BUILD_NUMBER,
  BRANCH,
  COMMIT_ID,
}
